import * as React from "react"

import { cva, type VariantProps } from "../cva.ts"
import { withClass } from "../to-wrapped-children.ts"
import { useFieldRefs } from "./field.tsx"

export const Label = ({ description, ...props }: Label.Props) => {
  const field = useFieldRefs()
  const ref = React.useRef<HTMLLabelElement | null>(null)

  React.useImperativeHandle(props.ref, () => ref.current!)
  React.useImperativeHandle(field.label, () => ref.current!)

  const label = (
    <label
      data-ui="Label"
      id={field.uuid("label")}
      htmlFor={field.uuid("control")}
      ref={ref}
      {...withClass(props, classForLabel)}
    />
  )

  if (!description) return label

  return (
    <div className="flex flex-col gap-0.5">
      {label}
      <p id={field.uuid("description")} className="text-sm text-gray-11">
        {description}
      </p>
    </div>
  )
}

export namespace Label {
  export interface Props extends React.ComponentProps<"label">, VariantProps<typeof classForLabel> {
    description?: React.ReactNode
  }
}

export const classForLabel = cva(["text-sm text-gray-12"])
